import React from 'react'

const ToolsIcon = ({icon}) => {
  return (
    <div>
      <img src={icon} alt="" />
    </div>
  )
}

export default ToolsIcon
